<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DYX2LK/tc-custom/9781453271858.jpg?1708749524840" alt="This image is the cover for the book Looking for Juliette, Investigators of the Unknown"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Looking for Juliette, Investigators of the Unknown
      </h1>
      <p class="bookDescription body article font2">
        <b>Poco is horrified when Angela’s cat disappears while under her watch. Is magic involved?</b><br/><br/>Together, Angela, Poco, and Georgina have investigated some peculiar happenings. They are just on the verge of a major magical breakthrough when Angela’s father moves to Mexico, taking Angela and breaking up the trio of friends. As consolation, Angela gives Poco her cat, Juliette, to care for and talk to while she’s gone. Talking to animals is Poco’s special skill, but no words can stop Juliette from running into the street in front of a car. Though she survives the accident, Juliette vanishes, and it will take a miracle to find her. With the help of Walter Kew, a secretive boy in her class, and his Ouija board, Poco scans the neighborhood. When all mystical signs point to Miss Bone, the strange old spinster who’s been taking care of Angela’s house, Poco is quick to face her fears. She’ll do anything for Angela—and for Juliette. This ebook features a personal history by Janet Taylor Lisle including rare images and never-before-seen documents from the author’s own collection.<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Janet Taylor Lisle
      </h2>
      
      <p class="authorDescription body article">Janet Taylor Lisle (b. 1947) is an author of children&rsquo;s fiction. After growing up in Connecticut, Lisle graduated from Smith College and spent a year working for the volunteer group VISTA (Volunteers in Service to America) before becoming a journalist. She found that she loved writing human interest and &ldquo;slice of life&rdquo; stories, and honed the skills for observation and dialogue that would later serve her in her fiction.&#160;Lisle took a fiction writing course in 1981, and then submitted a manuscript to Richard Jackson, a children&rsquo;s book editor at Bradbury Press who was impressed with her storytelling. Working with Jackson, Lisle published her first novel, <i>The Dancing Cats of Applesap</i>, in 1984. Since then she has written more than a dozen books for young readers, including <i>The Great Dimpole Oak</i> (1987) and <i>Afternoon of the Elves</i> (1989), which won a Newbery Honor. Her most recent novel is <i>Highway Cats </i>(2008).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d86b6884